module.exports = __webpack_public_path__ + "abd666d21dccb6c52f3cb03d9c2eea98.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/ladybug.svg
// module id = 90
// module chunks = 0